import {
    useCallback, useMemo,
} from 'react'

import DomainObjectForm from 'app/shared-components/DomainObjectForm'
import SkyNetStepperButtons from 'app/shared-components/SkyNetStepper/SkyNetStepperButtons'
import useValidation from 'app/hooks/useValidation/useValidation'
import StatusHandler from 'app/shared-components/StatusHandler'
import useGetProductTypesForTempRange
    from 'app/common/PreBooking/components/PreBookingLaneDetails/hooks/useGetProductTypesForTempRange'

import useLongTermLeaseCreateContext from '../../LongTermLeaseFormContext'
import {
    LongTermLeaseType,
} from '../../../longTermLease.types'
import getFields from './containerDetails.fields'

const ContainerDetails = ({
    action,
    isPending,
    disabled,
}: {
    action: (data: LongTermLeaseType) => void,
    isPending: boolean,
    disabled: boolean,
}) => {
    const {
        activeStep,
        setActiveStep,
        setIsEdited,
        setValue,
        value,
        initialValue,
        exists,
    } = useLongTermLeaseCreateContext()

    const {
        productTypes,
        isDataReady,
        isFetching,
        isError,
        error,
    } = useGetProductTypesForTempRange({
        tempRange: value.secondStep.tempRange,
    })

    const fields = useMemo(() => {
        return getFields(productTypes)
    }, [productTypes])

    const {
        isValid,
    } = useValidation({
        fields,
        values: value.thirdStep,
    })

    const onChange = (newVal: Partial<LongTermLeaseType>) => {
        setValue({
            ...value,
            thirdStep: newVal,
        })
    }

    const handleNextAction = useCallback(() => {
        action({
            ...value.firstStep,
            ...value.secondStep,
            ...value.thirdStep,
            requiredContainers: value.thirdStep?.requiredContainers?.filter((item) => {
                return Object.values(item).every((el) => {
                    return Boolean(el)
                })
            }),
        } as LongTermLeaseType)
        setIsEdited(false)
    }, [
        action,
        setIsEdited,
        value.firstStep,
        value.secondStep,
        value.thirdStep,
    ])

    const backAction = useCallback(() => {
        setActiveStep(activeStep - 1)
        setValue({
            ...value,
            thirdStep: initialValue.thirdStep,
        })
    }, [
        setActiveStep,
        activeStep,
        setValue,
        value,
        initialValue.thirdStep,
    ])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <>
                <DomainObjectForm
                    value={value.thirdStep}
                    onChange={onChange}
                    fields={fields}
                    name="OrderByNumberView"
                    disabled={disabled}
                />
                <SkyNetStepperButtons
                    isValid={isValid}
                    nextLabel={exists ? 'Save' : 'Create'}
                    nextAction={handleNextAction}
                    canGoBack
                    backAction={backAction}
                    isLoading={isPending}
                />
            </>
        </StatusHandler>
    )
}

export default ContainerDetails
